import { UnidadePaginateResponse } from "features/unidades/typings/unidade";
import NewTable from "components/NewTable";
import useListagemUnidadeColumns from "./components/useListagemUnidadeColumns";
import { Control } from "react-hook-form";
import { FracaoForm } from "features/fracao/typings";

interface FracaoTableProps {
  data: UnidadePaginateResponse[];
  searchValue: string;
  onSearch: (q?: string) => any;
  isLoading?: boolean;
  control: Control<FracaoForm, object>;
  enabledEdit: boolean;
}

function FracaoTable({
  data,
  searchValue,
  onSearch,
  isLoading,
  control,
  enabledEdit = false,
}: FracaoTableProps) {
  const columns = useListagemUnidadeColumns({
    control,
    enabledEdit,
  });

  return (
    <NewTable
      // header={() => <HeaderTable value={searchValue} onSearch={onSearch} />}
      loading={isLoading}
      columns={[...columns]}
      dataSource={data ?? []}
      actions={[]}
    />
  );
}

export default FracaoTable;
